import { useRequest, useStorefront } from '@kega/sps-core';

const useUpdateProfile = () => {
    const { api: { occcustomer } } = useStorefront();
    const { error, loading, setRequest, setSuccess, setError } = useRequest();

    const updateProfile = async (profileField) => {
        try {
            setRequest();

            await occcustomer.updateProfileField(profileField);

            setSuccess();
        } catch (error) {
            console.log('[UpdateProfile]', error);
            setError(error);
            throw error;
        }
    }

    return {
        error,
        loading,
        updateProfile
    };
}

export default useUpdateProfile;